import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Navigate } from "react-big-calendar";

// Use the library's own constants to ensure compatibility
const NAV_KEYS = [Navigate.PREVIOUS, Navigate.TODAY, Navigate.NEXT] as const;

// Map Navigate constants to display symbols
const navigate = {
  [Navigate.PREVIOUS]: "<",
  [Navigate.TODAY]: "•",
  [Navigate.NEXT]: ">"
};
interface CalendarToolbarProps {
  onNavigate: (action: string) => void;
  TitleComp?: React.ComponentType;
  viewCounts?: number | undefined;
  onView: (view: string) => void;
  date: Date;
}
export default function CalendarToolbar(t0) {
  const $ = _c(25);
  let TitleComp;
  let date;
  let props;
  let t1;
  let viewCounts;
  if ($[0] !== t0) {
    const {
      onNavigate,
      viewCounts: t2,
      TitleComp: t3,
      onView: _,
      date: t4,
      ...t5
    } = t0;
    viewCounts = t2;
    TitleComp = t3;
    date = t4;
    props = t5;
    t1 = action => {
      onNavigate(action);
    };
    $[0] = t0;
    $[1] = TitleComp;
    $[2] = date;
    $[3] = props;
    $[4] = t1;
    $[5] = viewCounts;
  } else {
    TitleComp = $[1];
    date = $[2];
    props = $[3];
    t1 = $[4];
    viewCounts = $[5];
  }
  const handleNavigate = t1;
  const nextDate = date.getTime() + ((viewCounts || 7) - 1) * 86400000;
  let t2;
  if ($[6] !== date) {
    t2 = date.toLocaleDateString("en-IN", {
      day: "numeric"
    });
    $[6] = date;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== nextDate) {
    t3 = new Date(nextDate).toLocaleDateString("en-IN", {
      day: "numeric"
    });
    $[8] = nextDate;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== nextDate) {
    t4 = new Date(nextDate).toLocaleDateString("en-IN", {
      month: "short"
    });
    $[10] = nextDate;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const label = `${t2} - ${t3} ${t4}`;
  let t5;
  if ($[12] !== label) {
    t5 = <div className="text-md font-medium text-gray-900">{label}</div>;
    $[12] = label;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== handleNavigate) {
    t6 = NAV_KEYS.map((el, index) => <button key={el} onClick={() => {
      handleNavigate(el);
    }} className={`text-gray-700 px-3 py-0.5 text-xl hover:text-primary focus:outline-none transition-colors duration-150 ${index === 0 ? "rounded-l-md!" : "rounded-none"} ${index === NAV_KEYS.length - 1 ? "rounded-r-md" : ""} ${index > 0 ? "-ml-px" : ""}`} type="button"><span>{navigate[el]}</span></button>);
    $[14] = handleNavigate;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t6) {
    t7 = <div className="inline-flex" role="group">{t6}</div>;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== TitleComp) {
    t8 = TitleComp && <div className="flex justify-center sm:justify-start"><TitleComp /></div>;
    $[18] = TitleComp;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== props || $[21] !== t5 || $[22] !== t7 || $[23] !== t8) {
    t9 = <div className="flex gap-2 my-2 w-full justify-between items-center" {...props}>{t5}{t7}{t8}</div>;
    $[20] = props;
    $[21] = t5;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}